import type { Media, Service, Studio } from "@/lib/api/schemas";

/**
 * Which photo the site shows. The owner's own photos always win over the
 * examples from business.json (config), so the cabinet can replace every
 * picture without a republish; deleting the owner's photo brings the example back.
 */

/** Cover: the owner's latest, else the configured one. */
export function coverMedia(studio: Studio): Media | undefined {
  const owner = studio.media.filter((m) => m.kind === "cover" && m.origin === "owner");
  return owner.at(-1) ?? studio.media.find((m) => m.kind === "cover");
}

/** "Works": only the owner's photos once there is at least one, else the examples. */
export function galleryMedia(studio: Studio): Media[] {
  const gallery = studio.media.filter((m) => m.kind === "gallery");
  const owner = gallery.filter((m) => m.origin === "owner");
  return owner.length ? owner : gallery;
}

/** A service's photo path: the owner's latest for this service, else the configured one. */
export function serviceImagePath(studio: Studio, service: Service): string | null {
  const owner = studio.media.filter((m) => m.kind === "service" && m.origin === "owner" && m.service_id === service.id);
  return owner.at(-1)?.path ?? service.image_path;
}
